export default {
  auth: {
    isAuthenticated: false,
    currentUser: null,
    isLoading: false,
  },
  posts: [
    {
      id: '1',
      name: 'Post 1',
      content: 'Post 1 Content',
    },
    {
      id: '2',
      name: 'Post 2',
      content: 'Post 2 Content',
    },
  ],
  post: {},
};



// WEBPACK FOOTER //
// ./src/app/states/initial.js